import get from 'lodash/get';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import { ContentLoader } from 'vue-content-loader';
import IconCard from '@/assets/icons/card.svg';
import IconPremium from '@/assets/icons/premium.svg';
import { createNamespacedHelpers } from 'vuex';
import * as Filters from '@/global/filters';
import Level from '@/global/level.directive';
import UserFields from './user.fields.json';
import noUserImage from '@/assets/noprofile.png';

Vue.use(VueClipboard);

const { mapState: mapUserState } = createNamespacedHelpers('User');

export default {
  name: 'AccountInfo',
  components: { ContentLoader, IconCard, IconPremium },

  computed: {
    ...mapUserState({
      currentUser: state => state.currentUser,
      isPremiumUser: state => state.isCurrentUserPremium,
      premiumExpiryDate: state => state.currentUserPremiumExpiryDate
    }),

    profilePicture: function() {
      const { profilePhoto } = this.currentUser || { profilePhoto: null };

      if (profilePhoto) return profilePhoto;
      return noUserImage;
    },

    fullName: function() {
      if (!this.currentUser) return null;
      const { firstName, lastName } = this.currentUser;
      return `${firstName} ${lastName}`;
    },

    stripeUrl: function() {
      const unknown = { stripeCustomerID: null };
      const { stripeCustomerID } = this.currentUser || unknown;
      if (!stripeCustomerID) return null;

      return `https://dashboard.stripe.com/customers/${stripeCustomerID}`;
    },

    infoEmail: function() {
      const { infoItems } = UserFields;
      const { currentUser: user } = this;

      return Level.canAccess('chat.userinfo.account.email')
        ? [{ ...infoItems.email, value: user.email }]
        : [];
    },

    /**
     * User Information Items
     */

    // eslint-disable-next-line max-lines-per-function, complexity
    infoItems: function() {
      const { infoItems } = UserFields;
      const { currentUser: user } = this;

      if (!user) return infoItems;

      const unknown = { country: '-', city: '-', timezone: '-' };
      const location = get(user, 'ipDetails[0].location') || unknown;
      const os = get(user, 'deviceInfo.ios') ? 'iOS' : 'Android';
      const signUp = Filters.formatFullDate(user.signupDateTime);
      const device = Filters.getDeviceInfo(user.deviceInfo);
      const premiumExpiryDate = Filters.formatFullDate(this.premiumExpiryDate);

      return [
        { ...infoItems.userId, value: user.userId },
        { ...infoItems.gender, value: user.gender },
        { ...infoItems.age, value: Filters.getAge(user.birthDate) },
        { ...infoItems.country, value: location.country },
        { ...infoItems.city, value: location.city },
        { ...infoItems.timezone, value: location.timezone },
        { ...infoItems.lang, value: Filters.formatLangCode(user.language) },
        { ...infoItems.authMethod, value: user.authMethod },
        ...this.infoEmail,
        { ...infoItems.signUp, value: signUp },
        { ...infoItems.os, value: os },
        { ...infoItems.appVersion, value: user.tabikoVersion },
        { ...infoItems.device, value: device },
        { ...infoItems.currency, value: user.currencyCode },
        this.isPremiumUser
          ? {
              ...infoItems.premiumExpiryDate,
              value: premiumExpiryDate
            }
          : {}
        // ...(this.premiumExpiryDate
        //   ? [
        //       {
        //         ...infoItems.premiumExpiryDate,
        //         value: premiumExpiryDate
        //       }
        //     ]
        //   : [])
      ];
    }
  },

  methods: {
    replaceWithNoPic(e) {
      e.target.src = noUserImage;
    }
  }
};
